<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  min-height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
}

@media only screen and (max-width: 600px) {
  #app {
      align-items: flex-start;
  }
}

* {
  margin: 0;
  padding: 0;
}
</style>
<script>
export default {
  name: "App",
  metaInfo: {
    title: "Secure your deposits & payments.",
    meta: [
      {
        property: "og:title",
        content: "Secure your deposits & payments.",
        vmid: "og:title",
      },
    ],
  },
};
</script>
